import { fetchUtils } from 'react-admin';
import apiURL from '../apiURL';

export const silentAdminRequest = (
    path: string,
    options: any = {}
) => {
    const headers =
        options.headers ||
        new Headers({
            Accept: 'application/json',
        });

    const token =
        localStorage.getItem('auth') || '';

    headers.set(
        'Authorization',
        `Bearer ${token}`
    );

    return fetchUtils.fetchJson(
        `${apiURL}${path}`,
        {
            ...options,
            headers,
        }
    );
};
